import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postTenantDataVerified = (token, id, DataVerified) => {
    return fetch(`${apiUrl}tenants/${id}/data_verified`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            DataVerified
        })
    });
}

export default postTenantDataVerified

